export default {"src":"/_next/static/media/apple-button.d6fba3ce.svg","height":62,"width":209,"blurWidth":0,"blurHeight":0};